// Shared constants for the admin "auto-resolve" feature. Centralizing the phase
// and action strings here kills magic-string drift across the panel UI.
//
// IMPORTANT: the server side (functions/_shared/github.js +
// functions/api/admin/edit-requests/[id]/auto-resolve.js) uses the SAME literal
// strings, but it can't import from CRA src/, so those values are duplicated as
// literals there. If you change a value here, change it there too.

// Lifecycle phases derived live from GitHub each poll.
export const AUTO_RESOLVE_PHASES = {
  IDLE: 'idle',
  RUNNING: 'running',
  PR_OPEN: 'pr_open',
  MERGED: 'merged',
  FAILED: 'failed',
  NEEDS_HUMAN: 'needs_human',
};

// POST actions the panel can send to the auto-resolve endpoint.
export const AUTO_RESOLVE_ACTIONS = {
  RESOLVE: 'resolve',
  MERGE: 'merge',
  DISCARD: 'discard',
  ROLLBACK: 'rollback',
};

// ── Batch mode (docs/auto-resolve-batch.md §7, EXPERIMENTAL) ────────────────
// Same rule as above: the batch endpoints (functions/…/auto-resolve-batch)
// use these literals too and cannot import them.

// auto_resolve_batches.status
export const AUTO_RESOLVE_BATCH_STATUSES = {
  PREPARING: 'preparing',
  DISPATCHED: 'dispatched',
  RUNNING: 'running',
  PR_OPEN: 'pr_open',
  NEEDS_HUMAN_ONLY: 'needs_human_only',
  MERGED: 'merged',
  DISCARDED: 'discarded',
  FAILED: 'failed',
};

// POST /api/admin/accounts/:id/auto-resolve-batch { action }
// dismiss / restore fold a finished batch out of (or back into) the
// attention queue of the Batch runs strip and the per-school panel.
export const AUTO_RESOLVE_BATCH_ACTIONS = {
  DISPATCH: 'dispatch',
  MERGE: 'merge',
  DISCARD: 'discard',
  REFRESH: 'refresh',
  DISMISS: 'dismiss',
  RESTORE: 'restore',
};

// Per-request result status in results.json (§6).
export const AUTO_RESOLVE_BATCH_RESULTS = {
  DONE: 'done',
  NEEDS_HUMAN: 'needs_human',
  SKIPPED: 'skipped',
};

// Classification buckets (functions/_shared/auto-resolve-classify.js, §5).
export const AUTO_RESOLVE_BATCH_BUCKETS = {
  AUTO: 'auto',
  REVIEW: 'review',
  HUMAN: 'human',
};

// At most this many requests per batch (§4).
export const AUTO_RESOLVE_BATCH_MAX = 12;
